export default __webpack_public_path__ + "static/media/NET_Core_Logo.e2aac1c9.svg";